import $ from 'jquery';
import 'jquery-match-height';
import 'slick-carousel';
export default {
  init: function init() {},
  finalize: function finalize() {
    var self = this;
    var pcWidth = 1024;
    var $facility = $('#facility .slider');

    if ($facility.get(0)) {
      $facility.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: false,
        arrows: true,
        infinite: true,
        appendArrows: $('#facility .l-mainvisual-arrowbox'),
        prevArrow: '<a class="prev"></a>',
        nextArrow: '<a class="next"></a>',
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }

    var $tool = $('#tool .slider');

    if ($tool.get(0)) {
      $tool.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: false,
        arrows: true,
        infinite: true,
        appendArrows: $('#tool .l-mainvisual-arrowbox'),
        prevArrow: '<a class="prev"></a>',
        nextArrow: '<a class="next"></a>',
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }

    var $equipment = $('#equipment .slider');

    if ($equipment.get(0)) {
      $equipment.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: false,
        arrows: true,
        infinite: true,
        appendArrows: $('#equipment .l-mainvisual-arrowbox'),
        prevArrow: '<a class="prev"></a>',
        nextArrow: '<a class="next"></a>',
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }

    $(window).on('load, resize', function () {
      $('[data-match-height-group]').each(function () {
        var group = $(this).data('match-height-group');
        var height = 0;

        if ($(this).outerHeight() > height) {
          height = $(this).outerHeight();
          $('[data-match-height-group="' + group + '"]').css('min-height', height);
        }
      });
      var windowAttr = {
        width: global.innerWidth
      };

      if (windowAttr.width > pcWidth) {
        var hoverClass = '.p-studio-schedule-container-table-cell-hover';
        var $schedule = $('.p-studio-schedule-container-table-cell, ' + hoverClass);
        $schedule.on('mouseenter', function () {
          if (($(this).find('.p-studio-schedule-container-table-cell-detail-name').html() !== '' || $(this).find('.p-studio-schedule-container-table-cell-detail-content').html() !== '') && $(this).find('.p-studio-schedule-container-table-cell-detail-nav').is(':hidden')) {
            $(this).find(hoverClass).css('display', 'flex');
          }
        });
        $schedule.on('mouseleave', function () {
          $(this).find(hoverClass).css('display', 'none');
        });
      }
    }).resize();
    $('.js-accordion-btn').on('click', function () {
      $(this).next().slideToggle();
      $(this).toggleClass('is-active');
    });
    $('.l-mainvisual-bnr_item').matchHeight();
    setTimeout(function () {
      self.asyncGoogleMap();
    }, 1000);
  },
  asyncGoogleMap: function asyncGoogleMap() {
    $('.js-google-map').each(function () {
      var map = $(this).data('map');
      $(this).after(map);
    });
  }
};